// Copyright: IQGeo Limited 2010-2022
import myw from 'myWorld/base/core';
import './input';

/**
 * @class  UnitInput
 * @param  {string} options.value input value
 * @param  {function} options.onChange callback fired onKeyUp and Blur
 *
 * @example
 *     new myw.UnitInput({value: "Hello World", onChange: function() {} })
 *
 * @extends {Input}
 */
myw.UnitInput = myw.Input.extend({
    events: {
        change: '_onChange'
    },

    initialize(options) {
        myw.Input.prototype.initialize.call(this, options);
        this.unitScale = new myw.UnitScale(options.unitScaleDef);
    },

    render(options) {
        myw.Input.prototype.render.call(this, options);
        const intialValue = this.options.value || '';
        if (intialValue.length) {
            this._creatUnitScale(intialValue);
        }
    },

    /**
     * Returns unit value
     * @return {UnitValue}
     */
    getUnitValue() {
        return this.value;
    },

    _onChange() {
        this._creatUnitScale(this.$el.val());
        myw.FormComponent.prototype._onChange.call(this);
    },

    _creatUnitScale(strInput) {
        this.clearError();
        try {
            this.value = this.unitScale.fromString(strInput, this.options.defaultUnit);
            this.setValue(this.value.toString());
        } catch (e) {
            let msgId;
            let msgArgs;
            if (e instanceof myw.UnitNotDefinedError) {
                msgId = `not_defined`;
                msgArgs = { text: e.message };
            } else if (e instanceof myw.ParseFloatError) {
                msgId = 'invalid_number';
            }
            if (msgId) this.renderError(this.msg(msgId, msgArgs));
            this.setValue(strInput);
            this.value = null;
        }
    }
});

export default myw.UnitInput;
